import { Component, OnDestroy, OnInit } from "@angular/core";
import { NetworkStatus } from "dialer";
import { combineLatest, firstValueFrom, interval, Subscription, timer } from "rxjs";
import { filter, takeWhile } from "rxjs/operators";
import { DialerClientService } from "../../core/services/dialer-client-service";

@Component({
    selector: "app-dialer-client-connection",
    templateUrl: "./dialer-client-connection.component.html",
    styleUrls: ["./dialer-client-connection.component.scss"],
})
export class DialerClientConnectionComponent implements OnInit, OnDestroy {
    dialerStatusMsg: string;
    networkStatus: NetworkStatus;
    networkStatusSubscription: Subscription;

    constructor(public dialerClientService: DialerClientService) {
        this.networkStatusSubscription = combineLatest<
            [boolean, NetworkStatus]
        >([
            this.dialerClientService.dialerService.initialized$.pipe(
                filter((bInitialized: boolean) => bInitialized)
            ),
            this.dialerClientService.networkStatus$,
        ]).subscribe(([_, status]) => {
            this.networkStatus = status;
            this.dialerStatusMsg = "";
            if (!this.networkStatus.ok) {
                const error = this.networkStatus.error;
                if ( !error ) {
                    this.dialerStatusMsg = "Dialer error occured"
                } else if (["Failed to fetch","GraphQL Websocket not connected"].includes(error.message)) {
                    this.dialerStatusMsg = "Unable to connect to Dialer service";
                } else {
                    this.dialerStatusMsg = `${error.message} (${error.name})`;
                }
            }
        });
    }

    ngOnInit(): void {}

    ngOnDestroy() {
        this.networkStatusSubscription?.unsubscribe();
    }

    resetting = false;
    async resetDialer() {
        if ( this.resetting ) {
            console.log('resetDialer() waiting...')
            await firstValueFrom(interval(1000).pipe(filter(cnt=>cnt>10||!this.resetting)))
        }
        console.log('resetDialer()')
        this.resetting = true;
        this.dialerStatusMsg = "";
        this.networkStatus = null;
        //this.dialerClientService.enableDialer(bEnable)
        try {
            await this.dialerClientService.dialerService.restart();
        } catch (error) {
            this.dialerClientService.appState.publishErrorObj(
                error,
                "Failed resetting dialer",
                this
            );
        } finally {
            this.resetting = false;
        }
    }
}
